import React, {Component} from 'react';
import GetHorizontalIrradiance from '../../utils/GlobalHorizontal';
import TableRow from '../../components/TableRow/TableRow';
import './Table.css';

export default class DataTable extends Component {
  render() {
    return(
      <table className="table table-dark" id="mytable">
  <thead>
    <tr>
      <th scope="col">Month</th>
      <th scope="col">Horizontal irradiance</th>
      <th scope="col">Optimum tilt irradiance</th>
      <th scope="col">Max ambient temperature</th>
      <th scope="col">Max no sun</th>
    </tr>
  </thead>
  <tbody>
    {this.props.irrData.map((data, index) =>
      <TableRow key={index} month={data.month} horizontal={data.horizontal} tilt={data.tilt} maxtemp={data.maxtemp} nosun={data.nosun} />
    )}
  </tbody>
</table>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/Table.js